// extracted by mini-css-extract-plugin
module.exports = {"holid-ad":"holid-ad_holid-ad__3Zlbf","holidAd":"holid-ad_holid-ad__3Zlbf","holid-ad-loaded":"holid-ad_holid-ad-loaded__xCmp3","holidAdLoaded":"holid-ad_holid-ad-loaded__xCmp3"};